import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

const NewStudent = ({ onFormSubmit }) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
  const [courses, setCourses] = useState([]);
  const [profileFile, setProfileFile] = useState(null);
  const [nricFile, setNricFile] = useState(null);
  const [educationFile, setEducationFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const CLOUDINARY_URL = baseURL;
  const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
  const [batches, setBatches] = useState([]);
  const [initialModulus, setInitialModulus] = useState(1)
  const [selectedBatch, setSelectedBatch] = useState(null)
  const [editFormData, setEditFormData] = useState({}); // Initialize form state
  const genderOptions = ["Male", "Female", "Other"];
  const [openDialog, setOpenDialog] = useState(false);
  const [alumniRegistrationId, setAlumniRegistrationId] = useState(null);
  const [allowAlumniRegistration, setAllowAlumniRegistration] = useState(null);
  const [pendingAlumniNric, setPendingAlumniNric] = useState("");
  const [warnings, setWarnings] = useState({});

  const [studentData, setStudentData] = useState({
    name: '',
    nric: '',
    email: '',
    phone: '',
    gender: '',
    dob: '',
    password: '',
    officephone: '',
    address: '',
    course: '',

    citizenship: '',
    postalcode: '',
    race: '',
    education: '',
    employmentstatus: '',
    salary: '',
    companyname: '',

    designation: '',
    profileUrl: '',
    batchId: null,
    startModulus: null,
    status: false,
    passport: '',
    passportExpiryDate: '',
    fatherName: '',
    brotherName: '',
    fatherPhoneNo: '',
    brotherPhoneNo: '',
    religion: '',
    currentAddress: '',
    institutionDetails: [],
    workExpirences: [],
    nricdoc: '',
    educationdoc: '',
    passportdoc: ''
  });



  const showAlumniConfirmationDialog = (nric) => {
    setPendingAlumniNric(nric);
    setOpenDialog(true);
  };

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await axios.get("batch-summary"); // API endpoint to get batches
        setBatches(response.data);
      } catch (error) {
        console.error("Error fetching batches:", error);
      }
    };

    fetchBatches();
  }, []);







  const [errors, setErrors] = useState({
    fullname: "",
    fatherName: "",
    brotherName: "",
    // course: "",
    religion: "",
    citizenship: "",
    nric: "",
    brotherPhoneNo: "",
    officephone: "",
    fatherPhoneNo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    // const nricRegex = /^[A-Z]\d{7}[A-Z]$/;

    // Regex to allow only letters and spaces
    const lettersOnlyRegex = /^[a-zA-Z\s]*$/;

    // Regex to allow only numbers
    const onlyNumberRegex = /^[0-9]*$/;

    let errorMessage = "";

    // Check if the field is a text-only field and validate
    if ((name === "fullname" || name === "fatherName" || name === "brotherName" || name === "course" || name === "religion" || name === "citizenship") && !lettersOnlyRegex.test(value)) {
      errorMessage = "Only letters are allowed.";
    }

    // if (name === "nric" && value.length === 9 && !nricRegex.test(value)) {
    //   errorMessage = "NRIC must be in the format: 1 capital letter, 7 digits, 1 capital letter (e.g., K1234567H).";
    // }

    if ((name === "fatherPhoneNo" || name === "officephone" || name === "brotherPhoneNo") && !onlyNumberRegex.test(value)) {
      errorMessage = "Only numbers are allowed.";
    }

    if (name === "passportExpiryDate") {
      // Extract the year from the date input
      const year = value.split("-")[0];

      // Check if the year is more than 4 digits
      if (year.length > 4) {
        errorMessage = "Year cannot be more than 4 digits.";
      }
    }
    if (name === "dob") {
      // Extract the year from the date input
      const year = value.split("-")[0];

      // Check if the year is more than 4 digits
      if (year.length > 4) {
        errorMessage = "Year cannot be more than 4 digits.";
      }
    }

    // Update the error state
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));

    // Update student data only if validation passes
    if (!errorMessage) {
      setStudentData({
        ...studentData,
        [name]: value,
      });
    }

    if (name === "course") {
      // Find the selected batch details
      const selectedBatch = batches.find((batch) => batch.course === value);
      setSelectedBatch(selectedBatch);
      setInitialModulus(selectedBatch?.currentModule);
      // Update studentData with course, batchId, and currentModule
      setStudentData((prevData) => ({
        ...prevData,
        course: value, // Selected course name
        batchId: selectedBatch?.id || null, // Selected batchId
        startModulus: selectedBatch?.currentModule || null, // Selected currentModule
        enrollmentDate: "", // Reset enrollment date
      }));
    } else if (!errorMessage) {
      // Update student data only if validation passes
      setStudentData({
        ...studentData,
        [name]: value,
      });
    }
  };



  const handleNricEmailChange = async (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setWarnings((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    try {
      if (name === "nric") {
        const response = await axios.get(`/registrationadvances/findExists?nric=${value}`);
        const data = response.data;

        if (data === true) {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else if (data?.status === "Alumni") {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
          setAlumniRegistrationId(data.registrationId);
          setOpenDialog(true);
        } else if (data?.status === "Active") {
          setErrors((prev) => ({
            ...prev,
            [name]: `NRIC already exists with status: ${data.status}. Registration not allowed.`
          }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else if (data?.status === "New") {
          setErrors((prev) => ({ ...prev, [name]: "" })); // Don't block
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC already exists with status "New".`
          }));
        } else if (data?.status === "two-new") {
          setErrors((prev) => ({ ...prev, [name]: "" })); // Still don't block
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC has **two existing New registrations**.`
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        }
      }
      else if (name === "email") {
        const response = await axios.get(`/registrationadvances/exists?email=${value}`);
        const exists = response.data;

        if (exists === true) {
          setErrors((prev) => ({
            ...prev,
            [name]: `EMAIL already exists. Registration not allowed.`
          }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setWarnings((prev) => ({ ...prev, [name]: "" }));
        }
      }
    } catch (error) {
      console.error(`Error checking ${name}:`, error);
      setErrors((prev) => ({
        ...prev,
        [name]: `Error checking ${name}. Try again!`
      }));
      setWarnings((prev) => ({ ...prev, [name]: "" }));
    }
  };


 const handleProfileFileChange = (setFile) => (event) => {
    const file = event.target.files[0];
  if (!file) return;

  const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (file && file.size > 8 * 1024 * 1024) { // 8MB limit
      event.target.value = ""; // Reset file input
      alert("File size must be less than 8MB.");
    } 
     if (!allowedTypes.includes(file.type)) {
    event.target.value = "";
    toast.error("Invalid file type. Only PNG, JPG, or JPEG are allowed.");
    return;
  }

   setFile(file);

  };



  const handleFileChange = (setFile) => (event) => {
    const file = event.target.files[0];

    if (file && file.size > 8 * 1024 * 1024) { // 8MB limit
      event.target.value = ""; // Reset file input
      alert("File size must be less than 8MB.");
    } else {
      setFile(file);
    }
  };

  // const uploadFile = async (file, folderPath) => {
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
  //   formData.append('public_id', folderPath);

  //   const response = await fetch(baseURL, {
  //     method: 'POST',
  //     body: formData,
  //   });

  //   const data = await response.json();
  //   if (!data.secure_url) {
  //     throw new Error('Failed to upload file.');
  //   }
  //   return data.secure_url;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();


    // Check if any error messages exist in the errors state
    if (Object.keys(errors).length > 0 && Object.values(errors).some((error) => error.trim() !== "")) {
      toast.error("Please resolve all validation errors before submitting.");
      return;
    }

    if (allowAlumniRegistration === false) {
      toast.error("Alumni registration is not allowed for this NRIC.");

      return; // silently block submission
    }

    try {
      setIsUploading(true); // Set uploading state to true
      let profileUrl = "";
      let nricdoc = "";
      let passportdoc = "";
      let educationdoc = "";
      const offerDate = studentData.enrollmentDate;

      // Upload the files
      const uploadFile = async (file) => {
        if (file) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
          formData.append("public_id", `LMS/${file.name} +' - '+ ${timestamp}`);

          const response = await fetch(baseURL, {
            method: "POST",
            body: formData,
          });

          const data = await response.json();
          if (data.secure_url) {
            return data.secure_url;
          } else {
            throw new Error("Failed to upload file.");
          }
        }
        return "";
      };

      profileUrl = await uploadFile(profileFile);
      nricdoc = await uploadFile(nricFile);
      passportdoc = await uploadFile(passportFile);
      educationdoc = await uploadFile(educationFile);

      // Update student data with the uploaded URLs
      const updatedStudentData = {
        ...studentData,
        profileUrl,
        nricdoc,
        passportdoc,
        educationdoc,
        offerDate,
      };

      // Submit the student data
      const studentResponse = await axios.post("registrationadvances", updatedStudentData);
      console.log("Student data submitted successfully:", studentResponse.data);

      toast.success("Student added successfully"); window.location.reload();
    } catch (error) {
      console.error("Error submitting student data:", error);
      toast.error("Failed to submit student data. Please try again.");
    } finally {
      setIsUploading(false); // Set uploading state to false after the process
    }
  };


  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;
    const newInstitutionDetails = studentData.institutionDetails.map((institution, i) => {
      if (i === index) {
        return { ...institution, [name]: value };
      }
      return institution;
    });
    setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
  };

  const handleAddEducation = () => {
    setStudentData({
      ...studentData,
      institutionDetails: [
        ...studentData.institutionDetails,
        { institution: '', year: '', qualificationsAchieved: '' },
      ],
    });
  };

  const handleRemoveEducation = (index) => {
    const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
    setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
  };


  const handleWorkExperienceChange = (index, e) => {
    const { name, value } = e.target;
    const newWorkExperiences = studentData.workExpirences.map((experience, i) => {
      if (i === index) {
        return { ...experience, [name]: value };
      }
      return experience;
    });
    setStudentData({
      ...studentData,
      workExpirences: newWorkExperiences
    });
  };

  const handleAddWorkExperience = () => {
    setStudentData((prevState) => ({
      ...prevState,
      workExpirences: [
        ...prevState.workExpirences,
        { name: '', position: '', year: '' }
      ]
    }));
    setShowEmploymentFields(true); // Show employment fields after adding
  };

  const handleRemoveWorkExperience = (index) => {
    const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
    setStudentData({
      ...studentData,
      workExpirences: newWorkExperiences
    });
    if (newWorkExperiences.length === 0) {
      setShowEmploymentFields(false); // Hide employment fields if no experience entries
    }
  };
  const dayMapping = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  };

  const handleDateChange = (event) => {
    // Get the new date from the event
    const { value } = event.target;
    console.log("Selected Enrollment Date:", value);
    console.log("Selected Date:", selectedBatch);

    const newDate = dayjs(value);
    const currentDate = dayjs();

    const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
    const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

    if (selectedBatch?.status && newDate.isBefore(currentDate, 'day') && intakeStartDate) {
      toast.error("Enrollment date cannot be before today.");
      return;
    } else if (selectedBatch?.status && isDatePassed) {
      toast.error("Batch is not started yet.");
      return;
    } else if (selectedBatch?.status && !isDatePassed) {
      // If batch status is true, use current module and skip calculations
      setStudentData((prevStudentData) => ({
        ...prevStudentData,
        enrollmentDate: value,
        startModulus: selectedBatch?.currentModule,
      }));

      console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
      return; // Exit function
    }

    // const newDate = dayjs(value); // Create dayjs object from the new date
    const oldDate = dayjs();

    console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    console.log("New Date:", newDate.format('YYYY-MM-DD'));

    // Calculate the difference in months between the old and new dates
    let monthDifference = newDate.month() - oldDate.month();
    if (newDate.year() !== oldDate.year()) {
      monthDifference += (newDate.year() - oldDate.year()) * 12;
    }
    console.log("Month Difference:", monthDifference);

    // For advance diploma, the increment is simply the month difference
    let increment = monthDifference;
    console.log("Advance Diploma Course - Increment:", increment);

    // Calculate the new modulus value based on the increment
    let newModulus = initialModulus + increment;
    // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
    newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
    console.log("New Modulus Before Ensuring Range:", newModulus);

    const firstDay = selectedBatch.days[0]; // Assuming days is in the correct scope
    console.log("First Day from Data:", firstDay.day);

    const dayIndex = dayMapping[firstDay.day];
    // Determine the first occurrence of the specified day of the month
    const firstOfMonth = newDate.date(1); // Set to the first of the month
    let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

    // If the first occurrence is in the previous month, move to the next week
    if (firstSpecifiedDay.isBefore(firstOfMonth)) {
      firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
    }

    console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

    // Adjust modulus: if the enrollment date is after the first specified day,
    // add 1 to the new modulus.
    if (newDate.isAfter(firstSpecifiedDay)) {
      newModulus += 1;
      console.log("Adjusting Modulus by adding 1.");
    }

    // Ensure modulus value stays within the 1-12 range after adjustments
    newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;

    // Update the form data with the new values
    setStudentData((prevStudentData) => ({
      ...prevStudentData,
      enrollmentDate: value,
      startModulus: newModulus,
    }));

    console.log("Updated Form Data:", {
      startModulus: newModulus,
    });
  };

  const deleteAlumniRegistration = async () => {
    if (!alumniRegistrationId) return;

    try {
      await axios.delete(`/registrationadvances/${alumniRegistrationId}`);
    } catch (err) {
      console.error("Failed to delete alumni registration:", err);
    } finally {
      setOpenDialog(false);
      setAlumniRegistrationId(null);
    }
  };



  return (

    <div className="containerw mx-auto " style={{ maxWidth: '1200px', background: '#ffffff', padding: '20px', boxShadow: '0px 0px 2px 0px #000000', borderRadius: '10px', marginTop: '1%' }}>





      <h4 >New Student (Trent International Institute)</h4>
      <hr style={{ marginTop: '1%' }} />


      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'row' }} >

        <div style={{ marginRight: '20px', flex: 1 }}>
          <div className="form-grup">
            <label htmlFor="name">Name*</label>
            <input
              type="text"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="name"
              className="form-control"
              name="name"
              value={studentData.name}
              onChange={handleChange}
              required
            />
            {errors.fullname && <p style={{ color: "red" }}>{errors.fullname}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="nric">NRIC/FIN No*</label>
            <input
              type="text"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="nric"
              className="form-control"
              name="nric"
              value={studentData.nric || ""} // Ensure value is controlled
              onChange={handleNricEmailChange}
              required
              maxLength={10}
            />
            {/* Error message in red (blocks submission) */}
            {errors.nric && <p style={{ color: "red", margin: 0 }}>{errors.nric}</p>}

            {/* Warning message in orange (does NOT block submission) */}
            {warnings.nric && !errors.nric && (
              <p style={{ color: "#FFA500", margin: 0 }}>{warnings.nric}</p>
            )}          </div>

          <div className="form-group">
            <label htmlFor="email">Email*</label>
            <input
              type="email"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="email"
              className="form-control"
              name="email"
              value={studentData.email}
              onChange={handleNricEmailChange}
              required
              maxLength={100}
            />
            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
          </div>

          <div className="form-group">

            <label htmlFor="name">Passport Number*</label>
            <input
              type="text"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="passport"
              className="form-control"
              name="passport"
              value={studentData.passport}
              onChange={handleChange}
              maxLength={20}

            />
          </div>

          <div className="form-group">

            <label htmlFor="name">Passport ExpiryDate*</label>
            <input
              type="date"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="passportExpiryDate"
              className="form-control"
              name="passportExpiryDate"
              value={studentData.passportExpiryDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="course">Course*</label>
            <select
              id="course"
              className="form-control"
              name="course"
              value={studentData.course}
              onChange={handleChange}
              style={{ width: '100%', height: '46px', borderRadius: '6px', border: '1px solid #ced4da' }}
              required
            >
              <option value="">Select Course...</option>
              {batches.map((batch) => (
                <option key={batch.id} value={batch.course}>
                  {batch.course}
                </option>
              ))}
            </select>
          </div>



          <div className="form-group">

            <label htmlFor="Enrollment Date">Enrollment Date*</label>
            <input
              type="date"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              id="enrollmentDate"
              className="form-control"
              name="enrollmentDate"
              value={studentData.enrollmentDate || ""}
              onChange={handleDateChange}
              required
              disabled={!studentData.course}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="race">Religion*</label>
            <input
              type="text"
              id="race"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="religion"
              value={studentData.religion}
              onChange={handleChange}
              required
            />
            {errors.religion && <p style={{ color: "red" }}>{errors.religion}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="citizen">Citizenship*</label>
            <input
              type="text"
              id="citizenship"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="citizenship"
              value={studentData.citizenship}
              onChange={handleChange}
              required
            />
            {errors.citizenship && <p style={{ color: "red" }}>{errors.citizenship}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="phone">Office Phone</label>
            <input
              type="tel"  // Use "tel" type for phone numbers
              id="phone"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="officephone"
              value={studentData.officephone}
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
              }}
            />
            {errors.officephone && <p style={{ color: "red" }}>{errors.officephone}</p>}
          </div>





          <div>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{ mt: 2 }}
            >
              <Button
                type="button"
                variant="contained"
                fullWidth
                onClick={handleAddEducation}
              >
                + Add Education
              </Button>

              <Button
                type="button"
                variant="contained"
                fullWidth
                onClick={handleAddWorkExperience}
              >
                + Add Employment
              </Button>
            </Stack>
            <br />
            {studentData.institutionDetails.map((institution, index) => (
              <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }}>
                <div className="form-group">
                  <label htmlFor={`institutionName-${index}`}>Institution Name*</label>
                  <input
                    type="text"
                    id={`institutionName-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="institution"
                    value={institution.institution}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`degree-${index}`}>Degree*</label>
                  <input
                    type="text"
                    id={`degree-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="qualificationsAchieved"
                    value={institution.qualificationsAchieved}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`yearOfGraduation-${index}`}>Year of Graduation*</label>
                  <input
                    type="number"
                    id={`yearOfGraduation-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="year"
                    value={institution.year}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                  />
                </div>

                <button
                  type="button"
                  onClick={() => handleRemoveEducation(index)}
                  style={{
                    margin: '10px 0',
                    padding: '5px 15px',
                    fontSize: '16px',
                    backgroundColor: 'red',
                    color: 'white',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
        </div>

        <div style={{ flex: 1 }}>

          <div className="form-group">
            <label htmlFor="phone">Hand Phone*</label>
            <input
              type='number'  // Use "tel" type for phone numbers
              id="phone"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="phone"
              value={studentData.phone}
              onChange={handleChange}
              required
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
              }}
            />
            {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="gender">Gender*</label>
            <select
              id="gender"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="gender"
              value={studentData.gender}
              onChange={handleChange}
            >
              <option value="">Select Gender</option>
              {genderOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="dob">Date of Birth*</label>
            <input
              type="date"
              id="dob"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              className={`form-control`}
              name="dob"
              value={studentData.dob}
              onChange={handleChange}
              // max={formatDate(new Date())} // Set the max attribute to today's date
              required
            />
          </div>


          <div className="form-group">
            <label htmlFor="password">Password*</label>
            <input
              type="password"
              id="password"
              className="form-control"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              name="password"
              value={studentData.password}
              onChange={handleChange}
              required
            />
          </div>


          <div className="form-group">
            <label htmlFor="address">Home Address*</label>
            <input
              type="text"
              id="address"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="address"
              value={studentData.address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">Singapore Address</label>
            <input
              type="text"
              id="address"
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

              className="form-control"
              name="currentAddress"
              value={studentData.currentAddress}
              onChange={handleChange}
            />
          </div>

          <div className="form-group d-flex gap-3" style={{ flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label htmlFor="fatherName">Father Name</label>
              <input
                type="text"
                id="fatherName"
                className="form-control"
                name="fatherName"
                value={studentData.fatherName}
                onChange={handleChange}
                style={{
                  height: '42px',
                  borderRadius: '6px',
                  border: '1px solid #ced4da',
                }}
              />
              {errors.fatherName && <p style={{ color: 'red' }}>{errors.fatherName}</p>}
            </div>

            <div style={{ flex: 1, minWidth: '200px' }}>
              <label htmlFor="fatherPhoneNo">Father Phone No</label>
              <input
                type="text"
                id="fatherPhoneNo"
                className="form-control"
                name="fatherPhoneNo"
                value={studentData.fatherPhoneNo}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                }}
                style={{
                  height: '42px',
                  borderRadius: '6px',
                  border: '1px solid #ced4da',
                }}
              />
              {errors.fatherPhoneNo && <p style={{ color: "red" }}>{errors.fatherPhoneNo}</p>}
            </div>
          </div>
          <div className="form-group d-flex gap-3 mt-3" style={{ flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label htmlFor="address">Brother Name </label>
              <input
                type="text"
                id="brotherName"
                className="form-control"
                name="brotherName"
                value={studentData.brotherName}
                onChange={handleChange}
                style={{
                  height: '42px',
                  borderRadius: '6px',
                  border: '1px solid #ced4da',
                }}
              />
              {errors.brotherName && <p style={{ color: "red" }}>{errors.brotherName}</p>}
            </div>


            <div style={{ flex: 1, minWidth: '200px' }}>
              <label htmlFor="brotherPhoneNo">Brother Phone No</label>
              <input
                type="text"
                id="brotherPhoneNo"
                className="form-control"
                name="brotherPhoneNo"
                value={studentData.brotherPhoneNo}
                onChange={handleChange}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                }}
                style={{
                  height: '42px',
                  borderRadius: '6px',
                  border: '1px solid #ced4da',
                }}
              />
              {errors.brotherPhoneNo && <p style={{ color: "red" }}>{errors.brotherPhoneNo}</p>}
            </div>
          </div>
          <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="profileFile" className="form-label">Upload photo</label>
              <input
                type="file"
                id="profileFile"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleProfileFileChange(setProfileFile)}
                className="form-control"
              />
            </div>
            <div style={{ flex: 1 }}>
              <label htmlFor="nricFile" className="form-label">NRIC Document</label>
              <input
                type="file"
                id="nricFile"
                onChange={handleFileChange(setNricFile)}
                className="form-control"
              />
            </div>
          </div>
          <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="educationFile" className="form-label">Education Document</label>
              <input
                type="file"
                id="educationFile"
                onChange={handleFileChange(setEducationFile)}
                className="form-control"
              />
            </div>
            <div style={{ flex: 1 }}>
              <label htmlFor="passportFile" className="form-label">Passport Document</label>
              <input
                type="file"
                id="passportFile"
                onChange={handleFileChange(setPassportFile)}
                className="form-control"
              />
            </div>
          </div>

          <br /><br />


          {/* Employment Status Fields */}
          {showEmploymentFields && (
            studentData.workExpirences.map((experience, index) => (
              <div key={index} style={{ marginBottom: '15px', padding: '7px', border: '1px solid #ced4da', borderRadius: '6px' }}>
                <div className="form-group">
                  <label htmlFor={`companyname-${index}`}>Company Name*</label>
                  <input
                    type="text"
                    id={`companyname-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="name"
                    value={experience.name}
                    onChange={(e) => handleWorkExperienceChange(index, e)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`position-${index}`}>Position*</label>
                  <input
                    type="text"
                    id={`position-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="position"
                    value={experience.position}
                    onChange={(e) => handleWorkExperienceChange(index, e)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor={`year-${index}`}>Year*</label>
                  <input
                    type="number"
                    id={`year-${index}`}
                    style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                    className="form-control"
                    name="year"
                    value={experience.year}
                    onChange={(e) => handleWorkExperienceChange(index, e)}
                    required
                  />
                </div>

                {/* Button to remove the work experience entry */}
                <button
                  type="button"
                  onClick={() => handleRemoveWorkExperience(index)}
                  style={{
                    margin: '10px 0',
                    padding: '5px 15px',
                    fontSize: '16px',
                    backgroundColor: 'red',
                    color: 'white',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  Remove
                </button>
              </div>
            ))
          )}

          <Button
            type="submit"
            variant="contained"
            disabled={isUploading} // Disable button when uploading
            style={{
              float: 'right',
              // marginTop: '1%',
              padding: '8px 50px',
              fontSize: '16px',
              backgroundColor: isUploading ? 'green' : 'green', // Optional: Change color when disabled
              cursor: isUploading ? 'not-allowed' : 'pointer', // Optional: Change cursor when disabled
            }}
          >
            {isUploading ? 'Submitting...' : 'Submit'}
          </Button>


        </div >
      </form >
      <ToastContainer />


      <Dialog open={openDialog} onClose={() => {
        setOpenDialog(false);
        setAllowAlumniRegistration(false); // cancel = block form
      }}>
        <DialogTitle>Re-register Alumni?</DialogTitle>
        <DialogContent>
          This NRIC belongs to an alumni student. Are you sure you want to re-register?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialog(false);
              setAllowAlumniRegistration(false); // explicitly disallow
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await deleteAlumniRegistration();
              setAllowAlumniRegistration(true); // allow form submission
            }}
            color="primary"
          >
            Yes, Register
          </Button>
        </DialogActions>
      </Dialog>



    </div >
  );
};


const NewStudenth = ({ onFormSubmit }) => {
  return (
    <div>

      {/* <NavigationButtons /> */}
      <NewStudent onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default NewStudenth;
